var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyAppointments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 75,
    viewBox: "0 0 72 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.375 41.0418V16.2502C66.375 14.3715 65.6287 12.5699 64.3003 11.2415C62.972 9.91311 61.1703 9.16683 59.2917 9.16683H9.70833C7.82972 9.16683 6.02804 9.91311 4.69966 11.2415C3.37128 12.5699 2.625 14.3715 2.625 16.2502V65.8335C2.625 67.7121 3.37128 69.5138 4.69966 70.8422C6.02804 72.1706 7.82972 72.9168 9.70833 72.9168H38.0417M48.6667 2.0835V16.2502M20.3333 2.0835V16.2502M2.625 30.4168H66.375M52.2083 55.2085L69.9167 72.9168M52.2083 72.9168L69.9167 55.2085",
    stroke: "#2B2724",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAppointments);
export default __webpack_public_path__ + "static/media/emptyAppointments.c7c2424fbed80bea6790d59e1ce17855.svg";
export { ForwardRef as ReactComponent };